export default "__VITE_ASSET__BUKPcweV__"